// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-footer[data-v-6bdb0e5a] {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.layout-footer-warp[data-v-6bdb0e5a] {\n  margin: auto;\n  color: var(--prev-color-text-secondary);\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
